import { SphereAvatar } from "@components/header/sphere-avatar";
import { UNKNOWN_MEMBER_LABEL } from "@components/teams/teams-filters/teams-filter-constants";
import { getTeamMemberFilterId, parseTeamMemberFilterId } from "@components/teams/teams-filters/teams-filter-options";
import { getPrettyName, getUserInitials } from "@utils/user-utils";

/**
 * Returns the items to filter the teams by the members, sorted by name, each with the avatar of
 * the member. The applied members are listed too, even if they are not in the workspace anymore,
 * e.g. from an old link, so they can be removed.
 */
export function getTeamsMemberFilterItems(members, activeMemberFilterIds) {
  const memberItems = members.map(member => ({
    id: getTeamMemberFilterId(member.identity),
    label: getPrettyName(member),
    searchTerms: [member.email],
    icon: <SphereAvatar shouldUseSimplifiedAvatar size="small" initials={getUserInitials(member)} src={member.thumbnailUrl} />
  })).sort((a, b) => a.label.localeCompare(b.label));
  const knownIds = new Set(memberItems.map(({
    id
  }) => id));
  const unknownItems = activeMemberFilterIds.filter(filterId => !knownIds.has(filterId) && parseTeamMemberFilterId(filterId) !== undefined).map(filterId => ({
    id: filterId,
    label: UNKNOWN_MEMBER_LABEL,
    icon: <SphereAvatar shouldUseSimplifiedAvatar size="small" />
  }));
  return Object.fromEntries([...memberItems, ...unknownItems].map(item => [item.id, item]));
}